import { AGraph } from '../../../core/Graph';

import { PostureMapEdge } from './Edge';
import { PostureMapNode } from './Node';

export class PostureMap extends AGraph<PostureMapNode, PostureMapEdge> {}
